function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import styled from 'styled-components';
import { color } from 'styled-system';
import PropTypes from 'prop-types';
import styledPropTypes from '@styled-system/prop-types';
import { shouldForwardProp } from '../../utils';
import { strictSpace } from '../../utils';
/**
 * Renders text link.
 */

export var StyledLink = styled.a.withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "Link__StyledLink",
  componentId: "sc-j061a1-0"
})(["text-decoration:", ";&:hover,&:active{text-decoration:none;}font-family:inherit;color:inherit;cursor:pointer;border:none;font-size:100%;background-color:transparent;appearance:none;box-shadow:none;", " ", ";"], function (props) {
  return props.unstyled ? 'none' : 'underline';
}, strictSpace, color);
var Link = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var passDownProps = Object.assign({}, props);

  if (props.target === '_blank' && props.rel === undefined) {
    passDownProps.rel = 'noopener noreferrer';
  }

  return /*#__PURE__*/React.createElement(StyledLink, _extends({}, passDownProps, {
    ref: ref
  }));
});
Link.displayName = 'Link';
Link.propTypes = _objectSpread(_objectSpread({
  unstyled: PropTypes.bool
}, styledPropTypes.space), {}, {
  /** color can reference any of the [color variables](/#/Variables?id=colors) */
  color: PropTypes.string
}, styledPropTypes.color);
Link.defaultProps = {
  padding: 'none'
};
/** @component */

export default Link;